import Image from '@klv/atoms/image';

import * as s from './styles/featuresItemImage.module.css';

import type { IFeaturesItemImageProps } from './types';

const FeaturesItemImage = ({
  variant, image, link = '', ...rest
}: IFeaturesItemImageProps & React.HTMLAttributes<HTMLDivElement>) => (
  <div className={s.featuresImageWrapper} {...rest}>
    {link && (
      <a className={s.anchor} href={link} aria-label={image.altText}>
        <Image altText={image.altText} imageData={image.gatsbyImage} />
      </a>
    )}
    {!link && <Image altText={image.altText} imageData={image.gatsbyImage} />}
  </div>
);

export default FeaturesItemImage;
